export class KeyCodes {
    public static KEY_LEFT = 37
    public static KEY_UP = 38;
    public static KEY_RIGHT = 39;
    public static KEY_DOWN = 40;
    public static KEY_ENTER = 13;
  
    constructor() {
    }
}